// /assets/section-collection-grid-with-products.js
(() => {
    const MQ = "(min-width: 1000px)";
    const mq = window.matchMedia(MQ);
    const MAX_SHIFT = 150; // pixel max di spostamento (tuning a piacere)
    let sections = [];
    let scrollAttached = false;
    let rafId = null;

    function collectSections(root = document) {
        return Array.from(root.querySelectorAll(".section-collection-grid-with-products")).map(section => {
            const left = section.querySelector(".left-side .image-wrapper");
            const right = section.querySelector(".right-side .image-wrapper");
            return { section, left, right };
        });
    }

    function handleParallax() {
        rafId = null;
        if (!mq.matches || !sections.length) return;

        const viewportH = window.innerHeight;
        const scrollY = window.scrollY;

        sections.forEach(({ section, left, right }) => {
            if (!left || !right) return;

            const rect = section.getBoundingClientRect();
            const sectionTop = scrollY + rect.top;
            const sectionH = rect.height;

            // Evita calcoli se fuori viewport
            if (scrollY + viewportH < sectionTop || scrollY > sectionTop + sectionH) return;

            const progress = (scrollY + viewportH - sectionTop) / (sectionH + viewportH); // 0 → 1
            const shift = (progress - 0.5) * 2 * MAX_SHIFT; // -MAX → +MAX

            const moveDown = (0.6 * shift).toFixed(2); // left scende
            const moveUp = (-0.6 * shift).toFixed(2);  // right sale

            left.style.transform = `translate3d(0, ${moveDown}px, 0)`;
            right.style.transform = `translate3d(0, ${moveUp}px, 0)`;
        });
    }

    function onScroll() {
        if (rafId == null) rafId = requestAnimationFrame(handleParallax);
    }

    function attachScroll() {
        if (scrollAttached) return;
        window.addEventListener("scroll", onScroll, { passive: true });
        scrollAttached = true;
    }

    function detachScroll() {
        if (!scrollAttached) return;
        window.removeEventListener("scroll", onScroll);
        scrollAttached = false;
    }

    function resetTransforms() {
        sections.forEach(({ left, right }) => {
            [left, right].forEach(el => {
                if (el) el.style.transform = "translate3d(0,0,0)";
            });
        });
    }

    function init(root = document) {
        sections = collectSections(root);

        if (mq.matches) {
            attachScroll();
            handleParallax();
        } else {
            detachScroll();
            resetTransforms();
        }
    }

    function boot() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
        } else {
            init(document);
        }
    }

    // Avvio
    boot();

    // Ricarico in editor Shopify
    document.addEventListener("shopify:section:load", e => init(e.target || document));
    document.addEventListener("shopify:section:select", e => init(e.target || document));

    // Cambio breakpoint
    const onMqChange = e => (e.matches ? init(document) : (detachScroll(), resetTransforms()));
    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else mq.addListener(onMqChange);
})();
